export enum IndirectSeedTypeGq {
  EXACT = 'EXACT',
  TRANSLATION = 'TRANSLATION',
  RENAMING = 'RENAMING',
  VOLUME_UPDATE = 'VOLUME_UPDATE',
  LONGTAIL_COMPARISON = 'LONGTAIL_COMPARISON',
  LONGTAIL_PREPOSITION = 'LONGTAIL_PREPOSITION',
  LONGTAIL_QUESTION = 'LONGTAIL_QUESTION',
  LONGTAIL_WORD = 'LONGTAIL_WORD',
  LONGTAIL_ALPHABETICAL = 'LONGTAIL_ALPHABETICAL',
  LONGTAIL_NUMBER = 'LONGTAIL_NUMBER',
  RELATED_KEYWORD = 'RELATED_KEYWORD',
  RELATED_URL = 'RELATED_URL',
  RELATED_SITE = 'RELATED_SITE',
}

export function indirectSeedTypeToString(indirectSeedType?: IndirectSeedTypeGq) {
  if (!indirectSeedType) return undefined;
  const cleaned = (indirectSeedType as string)
    .split('_')
    .map((w) => w.toLowerCase())
    .join(' ');
  return cleaned.slice(0, 1).toUpperCase() + cleaned.slice(1);
}
